import { PlatformApi } from '~/services/api/platform'

export class ReportingService extends PlatformApi {
  async getAdminStats() {
    return await this.get(`/reporting/admin/stats`)
  }

  async getAdminStatsAllTime() {
    return await this.get(`/reporting/admin/stats/all`)
  }

  async getAdminPaddockStats() {
    return await this.get(`/reporting/admin/stats/paddocks`)
  }

  async getAdminUserStats() {
    return await this.get(`/reporting/admin/stats/users`)
  }

  async getAdminUserActivity() {
    return await this.get(`/reporting/admin/stats/user-activity`)
  }

  async getAdminAppActivity() {
    return await this.get(`/reporting/admin/stats/app-activity`)
  }

  async getAdminBookingLeadTime() {
    return await this.get(`/reporting/admin/stats/booking-lead-time`)
  }

  async getAdminRealtimeLogs() {
    return await this.get(`/reporting/admin/realtime-logs`)
  }

  async getAdminRevenue() {
    return await this.get(`/reporting/admin/revenue`)
  }

  async getAdminRevenueAll() {
    return await this.get(`/reporting/admin/revenue/all`)
  }

  async getAdminBannedBreed() {
    return await this.get(`/reporting/admin/banned-breed`)
  }

  async getAdminCreditBalances() {
    return await this.get(`/reporting/admin/credit-balances`)
  }

  async getAdminCreditBalanceHistory() {
    return await this.get(`/reporting/admin/credit-balances/history`)
  }
}
